/* global axios */
import ApiClient from './ApiClient';

class BotFlowsAPI extends ApiClient {
  constructor() {
    super('bot_flows', { accountScoped: true });
  }

  export(id) {
    return axios.get(`${this.url}/${id}/export`);
  }
}

export default new BotFlowsAPI();
